module.exports = __webpack_public_path__ + "84fedd8b1293bf6769b357e703a614e9.pdf";